module.exports = __webpack_public_path__ + "static/img/cooperation-banner@2x.7a55540.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mainindex/cooperation-banner@2x.png
// module id = 970
// module chunks = 0